import React from 'react';
import { UserAvatar, Attachment } from 'components';
import "./message.scss";
import $ from "jquery";
import Utils from 'utils';

export function Message(props) {

    return (
        <div className={`${props.mine ? "message mine-message" : "message customer-message"}`}>
            <div className={`bubble-container`}>
                {!props.mine && <span className="avatar"><UserAvatar label={props.avatarLabel} icon={props.avatarIcon} image={props.avatarImage} /></span>}
                <span dir={`${Utils.isArabicFirstChar(props.message) ? 'rtl' : 'ltr'}`} className={`bubble  ${props.errorChat.error && 'error-message'}`}>
                    <strong className={`${props.mine && "mine-author"}`}>{props.author}</strong><br />
                    {props.withAttachment ?
                        <Attachment attachments={props.attachments} content={props.message} msgId={props.msgId} />
                        : props.message}
                </span>
                <div className="msg-reaction">
                    {props.reaction}
                </div>
                {props.mine && <span className="avatar"><UserAvatar label={props.avatarLabel} icon={props.avatarIcon} image={props.avatarImage} /></span>}
            </div>
            {props.errorChat.error ? <ErrorMessage message={props.errorChat.description}></ErrorMessage> :
                <small className="time-span" style={{ fontSize: "9px" }}>{resolveMessageTime(props.time)}</small>}
        </div>
    );
}


export const ErrorMessage = (props) => {
    //SHOW POPOVER FOR ERROR SENDING MESSAGE 
    $(document).ready(function () {
        $('[data-toggle="popover"]').popover();
    });

    return (
        <small className="time-span text-danger">
            <a href
                tabindex="0"
                data-toggle="popover"
                data-trigger="focus"
                data-content={props.message}
                title="Error sending message"
                style={{ cursor: "pointer" }}>
                <i className="bi bi-exclamation-triangle-fill error-ms" /> Error sending message! <span className="text-dark">click for more detail</span>
            </a>
        </small>
    );
}

const resolveMessageTime = (dateLocalString) => {
    let date = dateLocalString.split(',')[0];
    let time = dateLocalString.split(',')[1];
    return date === new Date().toLocaleString().split(',')[0] ? `Today,${time}` : dateLocalString;
}

